export const categories = [
  {
    slug: "life",
    name: "生活",
    icon: "ri-leaf-line",
    desc: "记录日常生活的温暖瞬间，收纳整理、旅行见闻与治愈系日常分享。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20minimalist%20lifestyle%20scene%20with%20soft%20natural%20light%2C%20cozy%20home%20interior%20details%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20photography%2C%20peaceful%20and%20airy%20atmosphere&width=600&height=400&seq=cat-life-01&orientation=landscape",
  },
  {
    slug: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    desc: "探店试吃、家常菜谱与深夜食堂，一起把好吃的分享给每一个人。",
    cover:
      "https://readdy.ai/api/search-image?query=appetizing%20food%20photography%20on%20a%20clean%20light%20table%2C%20fresh%20colorful%20dishes%20with%20steam%2C%20soft%20daylight%2C%20minimal%20background%2C%20warm%20appetizing%20tones%2C%20high%20detail%20culinary%20editorial%20style&width=600&height=400&seq=cat-food-01&orientation=landscape",
  },
  {
    slug: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    desc: "翻唱、原创与乐器演奏，用声音记录情绪，发现打动你的那首歌。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20music%20studio%20scene%20with%20acoustic%20guitar%20and%20warm%20stage%20lighting%2C%20soft%20bokeh%2C%20clean%20minimal%20background%2C%20rich%20amber%20tones%2C%20cinematic%20editorial%20photography&width=600&height=400&seq=cat-music-01&orientation=landscape",
  },
  {
    slug: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    desc: "精彩操作集锦、新游试玩与趣味解说，带你感受游戏的快乐与燃点。",
    cover:
      "https://readdy.ai/api/search-image?query=gaming%20setup%20scene%20with%20neon%20accent%20lights%20and%20controller%20on%20a%20clean%20desk%2C%20soft%20glow%2C%20dark%20minimal%20background%2C%20modern%20editorial%20photography%2C%20vivid%20atmosphere&width=600&height=400&seq=cat-game-01&orientation=landscape",
  },
  {
    slug: "funny",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    desc: "沙雕日常、整活名场面与爆笑合集，专治不开心，笑点密集预警。",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20bright%20comedic%20scene%20with%20colorful%20props%20and%20cheerful%20lighting%2C%20clean%20minimal%20background%2C%20warm%20vivid%20tones%2C%20fun%20editorial%20photography%2C%20energetic%20atmosphere&width=600&height=400&seq=cat-funny-01&orientation=landscape",
  },
];

export type Category = (typeof categories)[number];